import type { ChatMessageDto } from '@/lib/api/sessions.client';

const asString = (value: unknown): string | null => (typeof value === 'string' ? value : null);

/**
 * The model a stored message stands for, as ``resolveChatModel`` reads it.
 *
 * For a user message the backend records the model the turn was SENT to
 * (``metadata.model``), written the moment the message is stored — which is
 * what makes the pick visible while the answer is still streaming and not yet
 * in the database at all.
 *
 * For an answer it is the model the answer was REQUESTED on
 * (``metadata.requested_model_id``), not the one that served it. After a
 * fallback those differ, and reading the served one moved the whole chat onto
 * the fallback model without the user touching the selector (KAN-1403). Who
 * actually answered stays visible through ``servedBy``. Answers stored before
 * that field existed fall back to the served model.
 */
export const messageModelOf = (
  m: ChatMessageDto,
  rawMeta: Record<string, unknown>
): string | null =>
  asString(rawMeta['requested_model_id']) ??
  m.model_identifier ??
  asString(m.model_id) ??
  asString(m.modelId) ??
  asString(rawMeta['model']);
